export const METERS = ["eco", "hap", "intl", "stab"];
export const TURNS_PER_YEAR = 6;
export const TERM_YEARS = 5;
export const MAX_TURNS = TURNS_PER_YEAR * TERM_YEARS;
export const START_METERS = { eco: 50, hap: 50, intl: 50, stab: 50 };

const clamp = (v) => Math.max(0, Math.min(100, v));

export const applyEffects = (meters, effects) =>
  Object.fromEntries(METERS.map((k) => [k, clamp(meters[k] + (effects[k] || 0))]));

export const checkEnd = (meters, turn) => {
  for (const k of METERS) {
    if (meters[k] <= 0) return { over: true, reason: `${k}_low`, survived: false };
    if (meters[k] >= 100) return { over: true, reason: `${k}_high`, survived: false };
  }
  if (turn >= MAX_TURNS) return { over: true, reason: "survived", survived: true };
  return { over: false };
};

export const computeScore = (meters, turn, survived) => {
  const sum = METERS.reduce((a, k) => a + meters[k], 0);
  const maxDev = Math.max(...METERS.map((k) => Math.abs(meters[k] - 50)));
  return turn * 100 + sum + (100 - maxDev) * 5 + (survived ? 1000 : 0);
};

export const getTitleKey = (reason, meters) => {
  if (reason !== "survived") return reason;
  const avg = METERS.reduce((a, k) => a + meters[k], 0) / 4;
  if (avg >= 65) return "great";
  if (avg >= 50) return "good";
  if (avg >= 35) return "ok";
  return "meh";
};

export const termLength = (turn) => ({
  years: Math.floor(turn / TURNS_PER_YEAR),
  months: (turn % TURNS_PER_YEAR) * 2,
});

export const getBest = () => Number(localStorage.getItem("ps_best") || 0);
export const saveBest = (score) => {
  if (score > getBest()) localStorage.setItem("ps_best", String(score));
};
